"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _BulkUploadPanel = _interopRequireDefault(require("../BulkUploadPanel"));

var _components = require("../../../../components");

var _StepperOutlet = _interopRequireDefault(require("../../../../components/Stepper/StepperOutlet"));

var CreateContacts = function CreateContacts() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_StepperOutlet.default, null), /*#__PURE__*/_react.default.createElement(_components.StepTitle, {
    title: "Add contact(s)",
    subTitle: "Step 1/4"
  }), /*#__PURE__*/_react.default.createElement(_material.Paper, null, /*#__PURE__*/_react.default.createElement(_BulkUploadPanel.default, null)));
};

var _default = CreateContacts;
exports.default = _default;